import { AnchorProduct } from "../../../domain/projections/AnchorProduct";
import { AnchorProductRepository } from "../../../domain/repositories/AnchorProductRepository";
import { createHttpClients } from "../shared/createHttpClients";
import { mapAnchorProductsDtoToAnchorProducts } from "./responseMapper";

type AnchorProductsResponse = { anchorProductVariants: Parameters<typeof mapAnchorProductsDtoToAnchorProducts>[0] };

class AnchorProductRepositoryImpl implements AnchorProductRepository {
  private static instance: AnchorProductRepositoryImpl;

  private constructor() {}

  public static getInstance(): AnchorProductRepositoryImpl {
    if (!AnchorProductRepositoryImpl.instance) {
      AnchorProductRepositoryImpl.instance = new AnchorProductRepositoryImpl();
    }

    return AnchorProductRepositoryImpl.instance;
  }

  public async get(auth: string, apiUrl: () => string): Promise<AnchorProduct[]> {
    try {
      const { httpGet } = createHttpClients(auth, apiUrl);
      const response = await httpGet<AnchorProductsResponse>({
        endpoint: `/looks/v2/anchor-products`,
      });
      return mapAnchorProductsDtoToAnchorProducts(response.anchorProductVariants);
    } catch (error) {
      console.error(error);
      return Promise.reject(error);
    }
  }
}

export { AnchorProductRepositoryImpl };
